import { User } from '../contexts/UserContext';
import { profileImageAssetUrl } from './publicAssets';

const hasValue = (value: unknown) => {
  if (value === undefined || value === null) {
    return false;
  }

  const normalizedValue = String(value).trim();

  return (
    normalizedValue !== '' &&
    normalizedValue !== 'undefined' &&
    normalizedValue !== 'null'
  );
};

// Profile images live at
//   incrypt-public-assets-global.s3.ap-southeast-2.amazonaws.com/user-profile-images/<uuid>.jpg
// (see server userController.uploadProfilePicture). We build the URL from the
// user's uuid — no env var required. `refreshImage` is an optional cache-buster
// the client sets right after an upload so the new image replaces the cached one.
export const getProfilePictureUrl = (
  user: User | null | undefined,
  hasImageError: boolean
) => {
  if (hasImageError || !user?.uuid) {
    return undefined;
  }

  const refreshQuery = hasValue(user.refreshImage)
    ? `?refresh=${encodeURIComponent(String(user.refreshImage))}`
    : '';

  return `${profileImageAssetUrl(`${user.uuid}.jpg`)}${refreshQuery}`;
};
